// @mui
import Container from '@mui/material/Container';
// components
import { useSettingsContext } from 'src/components/settings';
import InterviewNewEditForm from '../interview-new-edit-form';
//

// ----------------------------------------------------------------------

export default function InterviewCreateView() {
  const settings = useSettingsContext();

  return (
    <Container sx={{height:"100%"}} maxWidth={settings.themeStretch ? false : 'lg'}>
      <InterviewNewEditForm />
    </Container>
  );
}
